import { BlockActions } from '@store/blockSaga/actions'
import { all, takeLatest } from 'redux-saga/effects'

import { addBlock } from './addBlock'
import { addBlockByPageContent } from './addBlockByPageContent'
import { blockOrderChange } from './blockOrderChange'
import { deleteBlock } from './deleteBlock'
import { duplicateBlock } from './duplicateBlock'

export function* blocksSaga() {
  yield all([
    takeLatest(BlockActions.changeBlockOrder, blockOrderChange),
    takeLatest(BlockActions.duplicateBlock, duplicateBlock),
    takeLatest(BlockActions.deleteBlock, deleteBlock),
    takeLatest(BlockActions.addBlock, addBlock),
    takeLatest(BlockActions.addBlockByPageContent, addBlockByPageContent),
  ])
}
